
import { defineComponent, onBeforeMount, ref } from 'vue';
import { RefreshCcwIcon } from 'vue-feather-icons';
import { invokeGetLearner } from '@/utils/admin/view_proxy_request_service';
import moment from 'moment';
// import { XIcon } from 'vue-feather-icons';

export default defineComponent({
  components: { RefreshCcwIcon },
  name: 'ViewRereviewRequests',
  setup() {
    const LearnerDetails = ref();
    const renderReady = ref();
    const proxyLearnerDetails = ref();
    const reviewCheckOne = ref([]);
    const reviewBtnShow = ref(false);
    const learnerTaskId = ref();
    const proxyStatus = ref();
    const selectedstatus = ref('');
    const showDeassignCol = ref(false);
    const showCompletionCol = ref(false);
    const deassignCount = ref(0);
    const completionCount = ref(0);
    const assignedcheckedOne = () => {
      // console.log('inside assignedCheckONe');
      reviewCheckOne.value = [];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showReviewBtn = (event: any, taskId: any, status: any) => {
      // console.log('Event', event);
      const cb = event.target.checked;
      if (cb === true && status === 'active') {
        reviewBtnShow.value = true;
        learnerTaskId.value = taskId;
      } else {
        reviewBtnShow.value = false;
      }
    };
    const getProxyLearner = async () => {
      try {
        renderReady.value = false;
        completionCount.value = 0;
        deassignCount.value = 0;
        showCompletionCol.value = false;
        showDeassignCol.value = false;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const res: any = await invokeGetLearner('/learnerTaskToProxyReview', { review_status: selectedstatus.value });

        proxyLearnerDetails.value = res.learnerToProxyAssign;
        proxyStatus.value = res.reviewStatus;
        // selectedstatus.value = proxyStatus.value.ACTIVE;
        for (let index = 0; index < proxyLearnerDetails.value.length; index += 1) {
          const response = proxyLearnerDetails.value[index];
          if (response.assignment_date) {
            response.assignment_date = moment(response.assignment_date).utc().format('YYYY-MM-DD');
          }
          if (response.submission_date) {
            response.submission_date = moment(response.submission_date).utc().format('YYYY-MM-DD');
          }
          if (response.proxy_requested_date) {
            response.proxy_requested_date = moment(response.proxy_requested_date).utc().format('YYYY-MM-DD');
          }
          if (response.completion_date) {
            completionCount.value += 1;
            response.completion_date = moment(response.completion_date).utc().format('YYYY-MM-DD');
          } else {
            response.completion_date = '';
          }
          if (response.deassignment_date) {
            deassignCount.value += 1;
            response.deassignment_date = moment(response.deassignment_date).utc().format('YYYY-MM-DD');
          } else {
            response.deassignment_date = '';
          }
        }
        // console.log(`deassignCount.value ${deassignCount.value}`);
        if (completionCount.value > 0) showCompletionCol.value = true;
        if (deassignCount.value > 0) showDeassignCol.value = true;
        renderReady.value = true;
      } catch (error) {
        // console.log(error);
      }
    };
    const refreshPage = async () => {
      reviewCheckOne.value = [];
      // selectedstatus.value = '';
      // console.log('selected Status Value', selectedstatus.value);
      // blankSelection.value = '';
      learnerTaskId.value = '';
      reviewBtnShow.value = false;
      await getProxyLearner();
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const getSelectedStatus = async (e: any) => {
      selectedstatus.value = e.target.value;
      // console.log('selected Status value', selectedstatus.value);
      // if (selectedstatus.value) {
      await getProxyLearner();
      // }
    };
    onBeforeMount(async () => {
      await getProxyLearner();
    });
    return {
      LearnerDetails,
      renderReady,
      proxyLearnerDetails,
      getProxyLearner,
      reviewCheckOne,
      reviewBtnShow,
      learnerTaskId,
      assignedcheckedOne,
      showReviewBtn,
      refreshPage,
      proxyStatus,
      getSelectedStatus,
      selectedstatus,
      showDeassignCol,
      showCompletionCol,
    };
  },
});
